// extracted by mini-css-extract-plugin
module.exports = {"tagsBlock":"TagsBlock_tagsBlock__SGTBy"};